import { MapGroupId } from "../../types";
import img from "../../mapImages/StreetsOfTarkov2D.webp";

const mapData = {
  groupId: MapGroupId.Streets,
  groupName: {
    en: "Streets of Tarkov",
    ru: "Улицы Таркова",
  },
  title: {
    en: "Main 2D",
    ru: "Главная 2D",
  },
  imgPath: img,
  extracts: [],
};

export default mapData;
